const LS_KEYS = {
  WFG_KNOWN_USER: 'wfg-known-user',
  WFG_EMAIL: 'wfg-email',
  WFG_SUBTOPICS_SEEN: 'wfg-subtopics-seen',
};

export default LS_KEYS;
